export interface ClockPort {
  now: () => number;
}

export const systemClockPort: ClockPort = {
  now: () => Date.now(),
};
